var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanreplayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.84 15.77l-.5 1.34 4.89 4 .95-1.16-3.49-2.85a4.67 4.67 0 0 0 2.16-1.1 3.72 3.72 0 0 0 1.08-2.08h.78v-1.5h-.85a3.92 3.92 0 0 0-.8-1.59h1.65V9.29h-6v1.5H12a2.54 2.54 0 0 1 2.33 1.58h-3.61v1.5h3.68a2.07 2.07 0 0 1-.59 1 4 4 0 0 1-2.97.9zM15.3 2.06a12.66 12.66 0 0 0-8.67 3.42V2.9h-1.5v3.94a.75.75 0 0 0 .75.75h3.89v-1.5H8.2a11.25 11.25 0 1 1 7.1 20A11.25 11.25 0 0 1 4.66 11.16l-1.42-.49a12.62 12.62 0 0 0-.69 4.14A12.75 12.75 0 1 0 15.3 2.06zm-8.67 4V6h0z",
    fill: "#231f20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 2.1,
    fill: "#40d0cb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanreplayment);
export default __webpack_public_path__ + "static/media/loanreplayment.6ceec006195ac124790f328f670647d8.svg";
export { ForwardRef as ReactComponent };